import List from "./List";
import Create from "./Create";
import Edit from "./Edit";

export const VariantCreate = Create;
export const VariantList = List;
export const VariantEdit = Edit;
